import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

export default class DisabledOnMobile extends React.Component {
  static propTypes = {
    size: PropTypes.number,
    fill: PropTypes.string,
    color: PropTypes.string,
  };

  static defaultProps = {
    size: 16,
    fill: '#777777',
    color: undefined,
  };

  render() {
    const { size, fill, color, ...restProps } = this.props;

    return (
      <SvgIcon style={{ fill: fill || color }} {...restProps}>
        {
          {
            16: (
              <>
                <path d="M17,10a1,1,0,0,0-1,1v8.10474A.89624.89624,0,0,1,15.1047,20H8.8953a.88943.88943,0,0,1-.633-.26221A1,1,0,0,0,6.848,21.152,2.8764,2.8764,0,0,0,8.8953,22h6.2094A2.89852,2.89852,0,0,0,18,19.10477V11A1,1,0,0,0,17,10Z" />
                <path d="M21.70711,2.293a1.00008,1.00008,0,0,0-1.41427,0L17.98509,4.60071A2.89936,2.89936,0,0,0,15.1047,2.00005H8.8953A2.89852,2.89852,0,0,0,6,4.89528V16.58579L2.29289,20.29292a1,1,0,0,0,1.41427,1.41417l17.99995-18A1,1,0,0,0,21.70711,2.293ZM8,4.89528a.89623.89623,0,0,1,.89529-.89523h6.2094A.89623.89623,0,0,1,16,4.89528V6.58582l-8,8Z" />
                <path d="M13,5.00005H11a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z" />
                <path d="M11.16884,18.55556a.904.904,0,0,0,.12446.1511A1.00284,1.00284,0,0,0,12,19a.96484.96484,0,0,0,.19553-.02,1.00448,1.00448,0,0,0,.18663-.05664,1.04238,1.04238,0,0,0,.17339-.09223,1.0177,1.0177,0,0,0,.2755-.27556,1.00817,1.00817,0,0,0,.14887-.36.96227.96227,0,0,0,0-.39111,1.00863,1.00863,0,0,0-.14887-.36,1.01583,1.01583,0,0,0-.2755-.27556,1.03869,1.03869,0,0,0-.17339-.09223.99914.99914,0,0,0-1.08886.21664.90239.90239,0,0,0-.12446.15115,1.00863,1.00863,0,0,0-.14887.36.96747.96747,0,0,0,0,.39111,1.00817,1.00817,0,0,0,.14887.36Z" />
              </>
            ),
          }[size]
        }
      </SvgIcon>
    );
  }
}
